import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';

export class NotificationService {
    constructor() {

    }

    GetUpdatedTicketPromise() {
        const service = modelServices.getNotificationServiceName("GetUpdatedTicket");

        return httpClient({
            url: modelServices.baseUrl + service.URL,
            method: service.Method
        });
    }

    GetNotificationWebSocketConnectUrl(ticket) {
        return modelServices.baseUrl + modelServices.getNotificationWebSocketServiceName("Connect").URL +
            "?ticket=" + ticket;
    }

    MarkUserNotificationsPerEntityAsReadPromise() {
        const service = modelServices.getNotificationServiceName("MarkUserNotificationsPerEntityAsRead");

        return httpClient({
            url: modelServices.baseUrl + service.URL,
            method: service.Method
        });
    }

    GetUnreadUserNotifactionsPerEntityCountPromise() {
        const service = modelServices.getNotificationServiceName("GetUnreadUserNotifactionsPerEntityCount");

        return httpClient({
            url: modelServices.baseUrl + service.URL,
            method: service.Method
        });
    }

    GetNotificationODataPromise(top, skip) {
        const service = modelServices.getNotificationServiceName("GetNotificationOData");
        const url = modelServices.baseUrl + service.URL +
            "$top=" + top +
            "&$skip=" + skip +
            "&$orderby=ID desc";

        return httpClient({
            url: url,
            method: service.Method
        });
    }
}

const notificationService = new NotificationService();

export { notificationService };